import React from "react";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { State } from "source/app/services/UI/State/State";
import { IMusicMenuState } from "../IMusicMenuState";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { Sounds } from "source/app/services/Sound/Sounds";

export function PlaylistLock({
    currentPlayListName,
    isLocked,
}: {
    currentPlayListName: string;
    isLocked: boolean;
}) {
    if (!isLocked) {
        return (
            <Hyperlink
                whenClicked={() => {
                    Sounds.electronic_tones_melodic_positive.Play();

                    State.ReadClass<IMusicMenuState>(
                        ESharedComponent.MusicMenu
                    ).setState({ selectedPlaylists: [currentPlayListName] });
                }}
                tooltip="click to lock to this playlist"
                classes={StyleClassAuto({
                    opacity: 0.5,
                })}
            >
                <Glyphicon icon={EGlyphicon.asterisk} />
            </Hyperlink>
        );
    }

    return (
        <Hyperlink
            whenClicked={() => {
                Sounds.electronic_tones_melodic_positive2.Play();

                State.ReadClass<IMusicMenuState>(
                    ESharedComponent.MusicMenu
                ).setState({ selectedPlaylists: undefined });
            }}
            tooltip="click to unlock playlist selection"
        >
            <Glyphicon icon={EGlyphicon.lock} />
        </Hyperlink>
    );
}
